import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@22.1.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_c8a3f3638d482530b44d62416ac3557f/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/buildhome/repo/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}